export enum AutoCheckinMode {
  DISABLED = 'DISABLED',
  AT_CLASS_START = 'AT_CLASS_START',
  ON_MMS_ATTENDANCE_CONFIRMED = 'ON_MMS_ATTENDANCE_CONFIRMED',
}

export class ClassBookingConfig {
  enabled: boolean;
  bookingRequiredForCheckin?: boolean;
  autoCheckinMode?: AutoCheckinMode;
  createMemberAccountForCheckin?: boolean;
  hasAccessPass?: boolean;
  checkinOnlyGym?: boolean;
  skipCheckinRequiredForMmsAccess?: boolean;
}
